import { GenericItem } from '@marty-js/api-sdk/types';
import { TypeCta } from '../types';

export const generateCtaByTypeCta = (
  typeCta: TypeCta,
  genericItem: GenericItem,
  translator: (key: string) => string,
): string => {
  switch (typeCta) {
    case 'product':
      return genericItem.price.price;
    case 'download':
      return translator('sdk.cta.download');
    case 'service':
      return translator('sdk.cta.online-service');
    default:
      return null;
  }
};
